/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cp_Pricing_Feat2Inputs */

const en_cp_pricing_feat2 = /** @type {(inputs: Cp_Pricing_Feat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lecturer as client viewer`)
};

const id_cp_pricing_feat2 = /** @type {(inputs: Cp_Pricing_Feat2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dosen sebagai client viewer`)
};

/**
* | output |
* | --- |
* | "Lecturer as client viewer" |
*
* @param {Cp_Pricing_Feat2Inputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const cp_pricing_feat2 = /** @type {((inputs?: Cp_Pricing_Feat2Inputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cp_Pricing_Feat2Inputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_cp_pricing_feat2(inputs)
	return en_cp_pricing_feat2(inputs)
});